import $ from 'jquery';
import CartFragments from './cart-fragments';

/* global x5script, wc_add_to_cart_params */

class AddToCartSingle {
  constructor() {
    this.isAjaxEnabled = x5script.addToCartAjax;

    this.dropdown = $('.js-product-variations-dropdown');
    this.addToCartBtn = $('.js-add-to-cart-btn');
    this.isProcessing = false;
    this.slideCart = $('.js-slide-cart');
    this.slideCartContent = this.slideCart.find('.js-slide-cart-inner');

    if (!this.addToCartBtn.length) {
      return;
    }

    this.cartFragments = new CartFragments();

    this.addToCart();
  }

  addToCart() {
    this.btn = $('.js-single-add-to-cart-btn');

    if (!this.btn.length) {
      return;
    }

    $(document).on('click', '.js-single-add-to-cart-btn', e => {
      e.preventDefault();
      const self = $(e.currentTarget);

      if (this.isProcessing) {
        return;
      }

      this.isProcessing = true;
      self.removeClass('is-added').addClass('is-loading');

      if (this.dropdown.length) {
        const item = self.parent();
        const selection = item.attr('data-selection');
        const attr = self.attr('data-attr-name');
        let select;
        if (attr.match(/^pa_/)) {
          select = this.dropdown.find(`select#${attr}`); // #pa_course-date
        } else {
          select = this.dropdown.find('select');
        }

        if (select.length) {
          const selectionExists = this.dropdown.find(
            `option[value="${selection}"]`,
          ).length;
          const variationsForm = select.closest('.js-variations-form');
          const variationsData = JSON.parse(
            variationsForm.attr('data-product_variations'),
          );

          const productId = variationsForm.attr('data-product_id');
          const variation = variationsData.find(
            obj =>
              obj.attributes[`attribute_${attr.toLowerCase()}`] === selection,
          );
          const variationId = variation.variation_id;

          if (selectionExists) {
            select.val(selection).trigger('change');

            const ajaxData = {
              action: 'add_to_cart_ajax',
              product_id: productId,
              product_sku: '',
              quantity: 1,
              variation_id: variationId,
            };

            $(document.body).trigger('adding_to_cart', [self, ajaxData]);

            $.ajax({
              type: 'post',
              url: wc_add_to_cart_params.ajax_url,
              data: ajaxData,
              success: response => {
                if (response.error && response.product_url) {
                  window.location = response.product_url;
                  return;
                }

                this.cartFragments.set(response.cart);

                if (response.cart_url) {
                  window.location = response.cart_url;
                  return;
                }

                $(document.body).trigger('added_to_cart', [
                  response.fragments,
                  response.cart_hash,
                  self,
                ]);

                this.slideCartContent.html(response.cart);
                this.slideCart.addClass('is-open');
              },
            });
          }
        } else {
          // error
        }
      } else {
        this.addToCartBtn.trigger('click');
      }

      $(document.body).on('added_to_cart', () => {
        self.removeClass('is-loading').addClass('is-added');
        this.isProcessing = false;
      });
    });
  }
}

export default new AddToCartSingle();



// WEBPACK FOOTER //
// ./src/scripts/modules/add-to-cart-single.js